import { Component, Injector } from '@angular/core';
import {
  StockDocMovementDto,
  StockDocMovementListDto,
  StockDocMovementService,
} from '@digiwall/goliath-documents/proxy';
import {
  StockDocListComponent,
  StockDocListComponentImports,
  StockDocListComponentProviders,
} from '../../stock-doc-list.component';
import { LocalizationService, SubscriptionService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { Router, ActivatedRoute } from '@angular/router';
import { DwGridDataSourceService } from '@digiwall/ag-grid';

@Component({
  selector: 'document-stock-movement-list',
  templateUrl: './stock-doc-movement-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: StockDocListComponentProviders,
  imports: StockDocListComponentImports,
})
export class StockDocMovementListComponent extends StockDocListComponent<
  StockDocMovementListDto,
  StockDocMovementDto,
  StockDocMovementService
> {
  constructor(
    docService: StockDocMovementService,
    router: Router,
    route: ActivatedRoute,
    confirmation: ConfirmationService,
    localizationService: LocalizationService,
    injector: Injector,
    subscriptionService: SubscriptionService,
    datasource: DwGridDataSourceService,
  ) {
    super(
      docService,
      router,
      route,
      confirmation,
      localizationService,
      injector,
      subscriptionService,
      datasource,
    );
  }
}
